import React from 'react';
import SectionHeader from '../../../components/UI/SectionHeader';
import { Card, CardContent } from '../../../components/UI/Card';

interface Props {
  title: string;
  description?: string;
  children: React.ReactNode;
  action?: React.ReactNode;
  noPadding?: boolean;
}

/** Consistent section wrapper for Phone Numbers dashboard (Finject-style blocks). */
const PhoneNumbersSection: React.FC<Props> = ({ title, description, children, action, noPadding }) => (
  <section className="space-y-3">
    <div className="flex items-start justify-between gap-4">
      <SectionHeader title={title} description={description} className="mb-0" />
      {action}
    </div>
    <Card className="border-border/80 shadow-sm overflow-hidden">
      <CardContent className={noPadding ? 'p-0' : 'p-4 md:p-5'}>{children}</CardContent>
    </Card>
  </section>
);

export default PhoneNumbersSection;
